var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"de-text-bar"},[_c('Bar',{attrs:{"value":100,"mode":'x',"color":_vm.color,"backgroundColor":'rgba(3,140,251,0.20)'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }